EASY.customFields.submitCfLongTextInlineEdit = function (event, form, tagId) {
  event.preventDefault();
  var textArea = $("textarea#" + tagId);
  if (!(typeof CKEDITOR === "undefined")) {
    textArea.val(CKEDITOR.instances[tagId].getData());
  }
  $.ajax({
    url: form.action,
    type: "PUT",
    data: $(form).serialize(),
    dataType: "json",
    tagId: tagId,
    form: form,
    complete: function (data) {
      if (!data.status.toString().startsWith("2")) {
        showFlashMessage(
          "error",
          (data.responseJSON || {}).errors,
          3000
        ).prependTo("#ajax-modal");
        if (!(typeof CKEDITOR === "undefined")) {
          CKEDITOR.instances[this.tagId]?.model.document.on(
            "change",
            enableSubmitButton.bind(null, this.form)
          );
        }
      } else {
        window.easy_lock_version = data.getResponseHeader(
          "X-Easy-Lock-Version"
        );
        window.easy_last_journal_id = data.getResponseHeader(
          "X-Easy-Last-Journal-Id"
        );
        window.issue_was_changed = true;
        var valueField = $('span.edited[data-tag-id="' + this.tagId + '"]');
        valueField.html($("textarea#" + this.tagId).val());
        valueField.removeClass("edited");
        hideModal();
        valueField.effect("highlight");
      }
    },
  });
};

function enableSubmitButton(form) {
  if (!form) return;
  const submitButton = form.querySelector(
    "input[type=submit], button[type=submit]"
  );
  if (!submitButton) return;
  submitButton.disabled = false;
}
